/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for EtablissementResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, EtablissementDTO, EtablissementSelectDTO, UserDTO, EtablissementViewDTO, EtablissementViewSimpleDTO } from "../models";

@Injectable({ providedIn: "root" })
export class EtablissementResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findAllEtablissement(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementDTO>>;
    findAllEtablissement(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementDTO>>>;
    findAllEtablissement(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementDTO>>>;
    findAllEtablissement(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addEtablissement(etab: EtablissementDTO, logo?: Blob, plaquette?: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementDTO>;
    addEtablissement(etab: EtablissementDTO, logo?: Blob, plaquette?: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementDTO>>;
    addEtablissement(etab: EtablissementDTO, logo?: Blob, plaquette?: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementDTO>>;
    addEtablissement(etab: EtablissementDTO, logo?: Blob, plaquette?: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (logo !== undefined) {
            formData.append('logo', logo);
        }
        if (plaquette !== undefined) {
            formData.append('plaquette', plaquette);
        }
        if (etab !== undefined) {
            formData.append('etab', String(etab));
        }

        return this.httpClient.request('post', url, {
            body: formData,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEtablissement(etab: EtablissementDTO, logo?: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementDTO>;
    updateEtablissement(etab: EtablissementDTO, logo?: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementDTO>>;
    updateEtablissement(etab: EtablissementDTO, logo?: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementDTO>>;
    updateEtablissement(etab: EtablissementDTO, logo?: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (logo !== undefined) {
            formData.append('logo', logo);
        }
        if (etab !== undefined) {
            formData.append('etab', String(etab));
        }

        return this.httpClient.request('put', url, {
            body: formData,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyEtablissement(id: number, observe?: 'body', options?: RequestOptions<'text'>): Observable<boolean>;
    notifyEtablissement(id: number, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<boolean>>;
    notifyEtablissement(id: number, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<boolean>>;
    notifyEtablissement(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/notify/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    achiveEtablissement(id: number, motif: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<boolean>;
    achiveEtablissement(id: number, motif: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<boolean>>;
    achiveEtablissement(id: number, motif: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<boolean>>;
    achiveEtablissement(id: number, motif: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/archive/${id}`;

        let params = new HttpParams();
        if (motif != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motif, 'motif');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementByIes(idIes: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementDTO>>;
    findAllEtablissementByIes(idIes: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementDTO>>>;
    findAllEtablissementByIes(idIes: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementDTO>>>;
    findAllEtablissementByIes(idIes: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/${idIes}`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelect(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelect(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelect(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelect(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPublics(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPublics(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPublics(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPublics(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-publics`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementsPublics(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementDTO>>;
    findEtablissementsPublics(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementDTO>>>;
    findEtablissementsPublics(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementDTO>>>;
    findEtablissementsPublics(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-publics`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementsPrives(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementDTO>>;
    findEtablissementsPrives(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementDTO>>>;
    findEtablissementsPrives(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementDTO>>>;
    findEtablissementsPrives(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFicheEtab(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementDTO>;
    getFicheEtab(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementDTO>>;
    getFicheEtab(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementDTO>>;
    getFicheEtab(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/fiche/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEmailUserEtablissement(idEtablissement?: number, email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    updateEmailUserEtablissement(idEtablissement?: number, email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    updateEmailUserEtablissement(idEtablissement?: number, email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    updateEmailUserEtablissement(idEtablissement?: number, email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEmailUserEtablissement1(idEtablissement?: number, email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    updateEmailUserEtablissement1(idEtablissement?: number, email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    updateEmailUserEtablissement1(idEtablissement?: number, email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    updateEmailUserEtablissement1(idEtablissement?: number, email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEmailUserEtablissement2(idEtablissement?: number, email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    updateEmailUserEtablissement2(idEtablissement?: number, email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    updateEmailUserEtablissement2(idEtablissement?: number, email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    updateEmailUserEtablissement2(idEtablissement?: number, email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEmailUserEtablissement4(idEtablissement?: number, email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    updateEmailUserEtablissement4(idEtablissement?: number, email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    updateEmailUserEtablissement4(idEtablissement?: number, email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    updateEmailUserEtablissement4(idEtablissement?: number, email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEmailUserEtablissement3(idEtablissement?: number, email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    updateEmailUserEtablissement3(idEtablissement?: number, email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    updateEmailUserEtablissement3(idEtablissement?: number, email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    updateEmailUserEtablissement3(idEtablissement?: number, email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEmailUserEtablissement6(idEtablissement?: number, email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    updateEmailUserEtablissement6(idEtablissement?: number, email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    updateEmailUserEtablissement6(idEtablissement?: number, email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    updateEmailUserEtablissement6(idEtablissement?: number, email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateEmailUserEtablissement5(idEtablissement?: number, email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    updateEmailUserEtablissement5(idEtablissement?: number, email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    updateEmailUserEtablissement5(idEtablissement?: number, email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    updateEmailUserEtablissement5(idEtablissement?: number, email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementProvisoire(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementProvisoire(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementProvisoire(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementProvisoire(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-provisoire`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementProvisoire1(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementProvisoire1(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementProvisoire1(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementProvisoire1(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-provisoire`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementProvisoire2(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementProvisoire2(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementProvisoire2(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementProvisoire2(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-provisoire`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementProvisoire4(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementProvisoire4(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementProvisoire4(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementProvisoire4(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-provisoire`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementProvisoire3(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementProvisoire3(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementProvisoire3(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementProvisoire3(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-provisoire`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementProvisoire6(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementProvisoire6(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementProvisoire6(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementProvisoire6(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-provisoire`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementProvisoire5(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementProvisoire5(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementProvisoire5(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementProvisoire5(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-provisoire`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementDefinitif(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementDefinitif(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementDefinitif(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementDefinitif(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-definitif`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementDefinitif1(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementDefinitif1(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementDefinitif1(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementDefinitif1(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-definitif`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementDefinitif2(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementDefinitif2(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementDefinitif2(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementDefinitif2(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-definitif`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementDefinitif4(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementDefinitif4(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementDefinitif4(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementDefinitif4(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-definitif`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementDefinitif3(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementDefinitif3(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementDefinitif3(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementDefinitif3(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-definitif`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementDefinitif6(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementDefinitif6(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementDefinitif6(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementDefinitif6(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-definitif`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateAgrementDefinitif5(idEtablissement?: number, nomFichier?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewDTO>;
    updateAgrementDefinitif5(idEtablissement?: number, nomFichier?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewDTO>>;
    updateAgrementDefinitif5(idEtablissement?: number, nomFichier?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewDTO>>;
    updateAgrementDefinitif5(idEtablissement?: number, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/update-agrement-definitif`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectIes(idIes?: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectIes(idIes?: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes(idIes?: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes(idIes?: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-selectIes`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectIes1(idIes?: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectIes1(idIes?: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes1(idIes?: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes1(idIes?: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-selectIes`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectIes2(idIes?: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectIes2(idIes?: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes2(idIes?: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes2(idIes?: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-selectIes`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectIes4(idIes?: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectIes4(idIes?: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes4(idIes?: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes4(idIes?: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-selectIes`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectIes3(idIes?: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectIes3(idIes?: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes3(idIes?: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes3(idIes?: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-selectIes`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectIes6(idIes?: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectIes6(idIes?: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes6(idIes?: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes6(idIes?: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-selectIes`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectIes5(idIes?: number, archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectIes5(idIes?: number, archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes5(idIes?: number, archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectIes5(idIes?: number, archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-selectIes`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPrives(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPrives(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPrives1(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPrives1(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives1(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives1(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPrives2(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPrives2(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives2(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives2(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPrives4(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPrives4(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives4(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives4(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPrives3(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPrives3(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives3(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives3(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPrives6(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPrives6(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives6(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives6(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEtablissementJsonEtablissementSelectPrives5(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<EtablissementSelectDTO>>;
    findAllEtablissementJsonEtablissementSelectPrives5(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives5(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<EtablissementSelectDTO>>>;
    findAllEtablissementJsonEtablissementSelectPrives5(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/list-etablissements-select-prives`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUserByEmail(email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findUserByEmail(email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findUserByEmail(email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findUserByEmail(email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/existe-email`;

        let params = new HttpParams();
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUserByEmail1(email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findUserByEmail1(email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findUserByEmail1(email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findUserByEmail1(email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/existe-email`;

        let params = new HttpParams();
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUserByEmail2(email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findUserByEmail2(email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findUserByEmail2(email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findUserByEmail2(email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/existe-email`;

        let params = new HttpParams();
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUserByEmail4(email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findUserByEmail4(email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findUserByEmail4(email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findUserByEmail4(email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/existe-email`;

        let params = new HttpParams();
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUserByEmail3(email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findUserByEmail3(email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findUserByEmail3(email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findUserByEmail3(email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/existe-email`;

        let params = new HttpParams();
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUserByEmail6(email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findUserByEmail6(email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findUserByEmail6(email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findUserByEmail6(email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/existe-email`;

        let params = new HttpParams();
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUserByEmail5(email?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findUserByEmail5(email?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findUserByEmail5(email?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findUserByEmail5(email?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/existe-email`;

        let params = new HttpParams();
        if (email != null) {
            params = HttpParamsBuilder.addToHttpParams(params, email, 'email');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementByUser(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewSimpleDTO>;
    findEtablissementByUser(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewSimpleDTO>>;
    findEtablissementByUser(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewSimpleDTO>>;
    findEtablissementByUser(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/etablissement-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementByUser1(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewSimpleDTO>;
    findEtablissementByUser1(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewSimpleDTO>>;
    findEtablissementByUser1(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewSimpleDTO>>;
    findEtablissementByUser1(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/etablissement-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementByUser2(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewSimpleDTO>;
    findEtablissementByUser2(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewSimpleDTO>>;
    findEtablissementByUser2(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewSimpleDTO>>;
    findEtablissementByUser2(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/etablissement-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementByUser4(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewSimpleDTO>;
    findEtablissementByUser4(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewSimpleDTO>>;
    findEtablissementByUser4(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewSimpleDTO>>;
    findEtablissementByUser4(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/etablissement-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementByUser3(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewSimpleDTO>;
    findEtablissementByUser3(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewSimpleDTO>>;
    findEtablissementByUser3(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewSimpleDTO>>;
    findEtablissementByUser3(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/etablissement-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementByUser6(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewSimpleDTO>;
    findEtablissementByUser6(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewSimpleDTO>>;
    findEtablissementByUser6(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewSimpleDTO>>;
    findEtablissementByUser6(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/etablissement-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEtablissementByUser5(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<EtablissementViewSimpleDTO>;
    findEtablissementByUser5(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EtablissementViewSimpleDTO>>;
    findEtablissementByUser5(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EtablissementViewSimpleDTO>>;
    findEtablissementByUser5(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/etablissement-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEmailUserEtablissement(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findEmailUserEtablissement(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findEmailUserEtablissement(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findEmailUserEtablissement(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEmailUserEtablissement1(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findEmailUserEtablissement1(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findEmailUserEtablissement1(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findEmailUserEtablissement1(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEmailUserEtablissement2(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findEmailUserEtablissement2(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findEmailUserEtablissement2(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findEmailUserEtablissement2(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEmailUserEtablissement4(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findEmailUserEtablissement4(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findEmailUserEtablissement4(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findEmailUserEtablissement4(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEmailUserEtablissement3(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findEmailUserEtablissement3(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findEmailUserEtablissement3(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findEmailUserEtablissement3(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEmailUserEtablissement6(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findEmailUserEtablissement6(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findEmailUserEtablissement6(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findEmailUserEtablissement6(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEmailUserEtablissement5(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserDTO>;
    findEmailUserEtablissement5(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserDTO>>;
    findEmailUserEtablissement5(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserDTO>>;
    findEmailUserEtablissement5(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/etablissements/email-user-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
